<template>
  <validation-observer
    v-if="shouldQuestionRender"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      v-bind="observer"
      :validated="formObserver.validated"
    >
      <!-- CAPACITY GENERIC -->
      <form-row
        id="taxi-capacity"
        :label="title"
        :error="formObserver.validated && !observer.valid"
      >
        <template #helpText>
          <p>{{ helpText.value }}</p>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_taxi-capacity`"
          name="Taxi Capacity"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="capacityModel"
            name="Taxi Capacity"
            :data-test="snakeCase(questionFields.taxiCapacity)"
            :items="capacityGeneric"
            :error="failed"
            :error-messages="(failed && capacityModel === null) ? getFieldErrors('taxiCapacity', { required: true }) : []"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <!-- CAPACITY OTHER -->
      <form-row
        v-if="isCapacityOther"
        id="taxi-capacity"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_taxi-capacity`"
          name="Taxi Capacity (Other)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.taxiCapacity"
            :data-test="`${snakeCase(questionFields.taxiCapacity)}_other`"
            :items="capacityOther"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select number', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

const otherOption = {
  value: true,
  text: 'Other',
  logical: true,
  logicalValue: '',
};

export default {
  name: 'question-taxi-capacity',
  extends: QuestionBase,
  data () {
    return {
      fields: ['taxiCapacity'],
      shownGenericElems: 3,
    };
  },
  computed: {
    isMobile () { return this.$vuetify.breakpoint.smAndDown; },
    overallCapacity () {
      /*
      If 'taxi type' = Black cab, display 3, …, 7, 8+.
      If 'taxi type' = Saloon display 3, …, 7, 8+.
      If 'taxi type' = MPV display 3, …, 7, 8+.
      If 'taxi type' = Minibus display 3, …, 15, 16+.
      If 'taxi type' = Other display 3, …, 15, 16+.
      */
      let maxPossible;

      if (this.stepData.taxiType === null || ![4, 5].includes(this.stepData.taxiType)) {
        maxPossible = 6;
      } else {
        maxPossible = 14;
      }

      return Array(maxPossible).fill().map((x, i, arr) => {
        const shifted = i + 3;
        if (i === arr.length - 1) {
          return {
            text: `${shifted}+`,
            value: shifted,
          };
        } else {
          return {
            text: shifted,
            value: shifted,
          };
        }
      });
    },
    overallCapacityQty () { return this.overallCapacity.length; },
    capacityGeneric () {
      return [
        ...this.overallCapacity.slice(0, this.shownGenericElems),
        otherOption,
      ];
    },
    capacityOther () { return this.overallCapacity.slice(this.shownGenericElems); },
    capacityModel: {
      get () {
        if (this.questionData.taxiCapacity === null) return null;
        return this.capacityGeneric.some(el => el.value === this.questionData.taxiCapacity) ? this.questionData.taxiCapacity : true;
      },
      set (val) {
        this.questionData.taxiCapacity = val.logical ? val.logicalValue : val.value;
      },
    },

    isCapacityOther () {
      return this.capacityModel !== null && !this.overallCapacity.slice(0, this.shownGenericElems).some(el => el.value === this.capacityModel);
    },
  },
  watch: {
    overallCapacityQty () {
      if (!this.overallCapacity.find(({ value }) => value === this.questionData.taxiCapacity)) this.questionData.taxiCapacity = null;
    },
  },
};
</script>
